import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/800.css';
import { createTheme } from '@mui/material';

export const colors = {
    black: '#000000',
    green: '#2CCC45',
    info: '#2A92E9',
    lightGrey: '#E5E5E5',
    orange: '#FF9D3B',
    outlier: '#B00E14',
    peach: '#FFC09F',
    primary: '#F9C132',
    purple: '#BC9CFF',
    red: '#EF3F25',
    transparent: 'transparent',
    white: '#FFFFFF',
    yellow: '#F8E71C',
};

const colorClasses: any = {};
Object.entries(colors).forEach(([name, value]) => {
    colorClasses[`.text-${name}`] = {
        color: value,
        fontWeight: 700,
    };
});

export const fontSizes = {
    h1: '42px',
    h2: '32px',
    h3: '18px',
    h4: '16px',
    h5: '14px',
    h6: '12px',
};

export const palettes = {
    dark: {
        background: {
            default: '#3C3B3B',
            paper: '#1E1E1E',
        },
        text: {
            primary: '#FFFFFF',
        },
    },
    light: {
        text: {
            primary: '#141414',
        },
    },
};

export const theme = createTheme({
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
                variant: 'contained',
            },
            styleOverrides: {
                root: {
                    fontSize: 17,
                    fontWeight: 600,
                    letterSpacing: 0.5,
                    lineHeight: 1,
                    padding: 12,
                    textTransform: 'none',
                },
                sizeSmall: {
                    padding: 4,
                },
                sizeLarge: {
                    borderRadius: 50,
                    fontSize: 20,
                    fontWeight: 700,
                    padding: '22px 60px',
                    whiteSpace: 'nowrap',
                    width: 'auto',
                },
            },
        },
        MuiCard: {
            defaultProps: {
                elevation: 0,
            },
            styleOverrides: {
                root: {
                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 40px',
                    position: 'relative',
                    width: '100%',
                    zIndex: 1,
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                ...colorClasses,
                hr: {
                    margin: 0,
                },
                ol: {
                    marginBottom: 0,
                    marginTop: 0,
                    paddingLeft: 24,
                },
                p: {
                    margin: 0,
                },
                picture: {
                    display: 'block',
                    lineHeight: 0,
                },
                ul: {
                    margin: 0,
                    paddingLeft: 24,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFF',
                },
            },
        },
    },
    palette: {
        action: {
            disabledBackground: '#D8D8D8',
            disabled: '#979797',
        },
        error: {
            main: '#DE4F3B',
        },
        primary: {
            main: colors.primary,
            light: '#FFE9BF',
        },
        secondary: {
            main: '#EBECEF',
        },
        success: {
            main: '#00A739',
        },
        warning: {
            main: '#EE9810',
        },
    },
    typography: {
        // Defaults
        body1: {
            fontSize: 18,
            fontWeight: 400,
            lineHeight: 1.444,
            letterSpacing: 0.75,
        },
        fontFamily: 'Montserrat, sans-serif',

        // Montserrat
        montserrat312: {
            fontSize: 12,
            fontWeight: 300,
            lineHeight: 1.167,
        },
        montserrat410: {
            fontSize: 10,
            fontWeight: 400,
        },
        montserrat412: {
            fontSize: 12,
            fontWeight: 400,
        },
        montserrat414: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.2,
        },
        montserrat418: {
            fontSize: 18,
            fontWeight: 400,
            lineHeight: 1,
        },
        montserrat420: {
            fontSize: 20,
            fontWeight: 400,
        },
        montserrat514: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.43,
        },
        montserrat518: {
            fontSize: 18,
            fontWeight: 500,
            lineHeight: 1.2,
        },
        montserrat529: {
            fontSize: 29,
            fontWeight: 500,
            lineHeight: 1.345,
        },
        montserrat614: {
            fontSize: 14,
            fontWeight: 600,
            lineHeight: 1.345,
        },
        montserrat616: {
            fontSize: 16,
            fontWeight: 600,
            lineHeight: 1.875,
        },
        montserrat618: {
            fontSize: 18,
            fontWeight: 600,
        },
        montserrat636: {
            fontSize: 36,
            fontWeight: 600,
        },
        montserrat718: {
            fontSize: 18,
            fontWeight: 700,
        },
        montserrat818: {
            fontSize: 18,
            fontWeight: 800,
        },
        montserrat828: {
            fontSize: 28,
            fontWeight: 800,
        },
        montserrat836: {
            fontSize: 36,
            fontWeight: 800,
        },
        montserrat840: {
            fontSize: 40,
            fontWeight: 800,
        },
    },
});
